// File: FactoryAboutSection.jsx
// Pure CSS | Factory About Section

import { ChevronRight } from 'lucide-react';
import React from 'react';
export default function AboutUsCard9() {
  return (<>
    <section className="card9-section">
      <div className="card9-img-panel">
        <img
          src="https://picsum.photos/800/600?random=50"
          alt="card9-workers"
          className="card9-main-img"
        />
      </div>

      <div className="card9-content">
        <h5 className="sup-ac-9">OUR SERVICES</h5>
        <h2 className="title-ac-9">About Factory</h2>
        <div className="underline-ac-9"></div>
        <p>
          There are many variations of passages of Lorem Ipsum available, but the majority have suffered
          alteration in some form by injected humour or randomised words which don't look even slightly
          believable.
        </p>

        <button className="card9-btn">GET A QUOTE <ChevronRight size={16} /></button>
      </div>
    </section>
    <style>{`
/* File: FactoryAboutSection.css */
:root {
  --orange: rgba(144, 202, 249,1);
  --dark: #101820;
}

.card9-section {
  display: flex;
  gap: 40px;
  padding: 60px 40px;
  background: #ffffff;
  align-items: center;
  font-family: Inter, sans-serif;
}

/* LEFT */
.card9-img-panel {
  flex: 1;
  background: linear-gradient(90deg, var(--orange) 0%, rgba(144, 202, 249,0.1) 100%);
  padding: 20px;
  border-radius: 20px;
}

.card9-main-img {
  width: 100%;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  display: block;
}

/* RIGHT */
.card9-content {
  flex: 1;
  background: #fbfbfb;
  padding: 30px 30px;
  border-radius: 16px;
  background-image: url('data:image/svg+xml,%3Csvg width=20 height=20 xmlns=http://www.w3.org/2000/svg%3E%3Cpath fill=%23ececec d=M0 0h2v2H0z%3E%3C/svg%3E');
}

.sup-ac-9 {
  font-size: 14px;
  font-weight: 700;
  color: var(--orange);
  letter-spacing: 1px;
}

.title-ac-9 {
  font-size: 34px;
  font-weight: 800;
  color: var(--dark);
  margin: 8px 0 10px;
}

.underline-ac-9 {
  width: 60px;
  height: 4px;
  background: var(--orange);
  margin-bottom: 18px;
}

.card9-content p {
  max-width: 480px;
  line-height: 1.7;
  font-size: 15px;
  color: #555;
  margin-bottom: 30px;
}

.card9-btn {
  background: var(--orange);
  padding: 12px 26px;display:flex;justify-content:space-between;
  border: none;
  border-radius: 40px;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
}

/* Responsive */
@media(max-width:960px){
  .card9-section { flex-direction: column; padding: 60px 5px; }
  .card9-content { text-align: center; }
  .card9-img-panel {padding: 0px 15px;}
  .underline-ac-9 { margin: 0 auto 18px; }
}`}</style>
    </>
  );
}
